(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('custom-cart-drawer')) return;

    var TAG = 'custom-cart-drawer';
    var CART_MUTATION = /\/cart\/(add|change|update|clear)(?:\.js|\.json)?(?:[?#]|$)/;

    function getLive() {
      return document.querySelector(TAG);
    }

    function rootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function urlOf(input) {
      if (!input) return '';
      if (typeof input === 'string') return input;
      if (typeof URL !== 'undefined' && input instanceof URL) return input.href;
      return input.url || '';
    }

    function sectionsIn(body) {
      try {
        if (!body) return [];
        if (typeof FormData !== 'undefined' && body instanceof FormData) {
          return String(body.get('sections') || '').split(',');
        }
        if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
          return String(body.get('sections') || '').split(',');
        }
        if (typeof body === 'string') {
          var parsed = JSON.parse(body);
          var list = parsed && parsed.sections;
          if (Array.isArray(list)) return list.map(String);
          return String(list || '').split(',');
        }
      } catch (e) {
        /* Body is not JSON; ignore */
      }
      return [];
    }

    /* Keep a reference to the browser fetch so drawer requests never loop through the interceptor */
    var nativeFetch = window.fetch.bind(window);

    /* Watch every cart mutation from the theme, apps or jQuery so the drawer always mirrors the real cart */
    if (!window.__ccdInterceptorsInstalled) {
      window.__ccdInterceptorsInstalled = true;

      window.fetch = function (input, init) {
        var promise = nativeFetch(input, init);
        try {
          var match = urlOf(input).match(CART_MUTATION);
          if (match) {
            var drawer = getLive();
            var handled = drawer && init && sectionsIn(init.body).indexOf(drawer.dataset.sectionId) !== -1;
            if (drawer && !handled) {
              promise
                .then(function (response) {
                  if (response && response.ok) {
                    var live = getLive();
                    if (live) live.onExternalChange(match[1]);
                  }
                })
                .catch(function () {});
            }
          }
        } catch (e) {
          /* Never break the original request */
        }
        return promise;
      };

      if (window.XMLHttpRequest) {
        var xhrOpen = XMLHttpRequest.prototype.open;
        var xhrSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
          this.__ccdUrl = String(url || '');
          return xhrOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function () {
          var xhr = this;
          var match = xhr.__ccdUrl && xhr.__ccdUrl.match(CART_MUTATION);
          if (match) {
            xhr.addEventListener('load', function () {
              if (xhr.status >= 200 && xhr.status < 300) {
                var live = getLive();
                if (live) live.onExternalChange(match[1]);
              }
            });
          }
          return xhrSend.apply(this, arguments);
        };
      }

      /* Open triggers: header cart icon plus any custom selectors set in the editor */
      document.addEventListener(
        'click',
        function (event) {
          var drawer = getLive();
          if (!drawer || event.defaultPrevented) return;
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          var selectors = ['[data-cart-drawer-open]'];
          var custom = (drawer.dataset.openSelectors || '').trim();
          if (custom) selectors.push(custom);
          var trigger = null;
          try {
            trigger = event.target.closest(selectors.join(','));
          } catch (e) {
            trigger = event.target.closest('[data-cart-drawer-open]');
          }
          if (!trigger || drawer.contains(trigger)) return;
          event.preventDefault();
          drawer.open(trigger);
        },
        true
      );

      document.addEventListener('shopify:section:select', function (event) {
        var drawer = getLive();
        if (drawer && event.detail && event.detail.sectionId === drawer.dataset.sectionId) {
          window.__ccdEditorOpen = true;
          drawer.open();
        }
      });

      document.addEventListener('shopify:block:select', function (event) {
        var drawer = getLive();
        if (drawer && event.detail && event.detail.sectionId === drawer.dataset.sectionId) {
          window.__ccdEditorOpen = true;
          drawer.open();
        }
      });

      document.addEventListener('shopify:section:deselect', function (event) {
        var drawer = getLive();
        if (drawer && event.detail && event.detail.sectionId === drawer.dataset.sectionId) {
          window.__ccdEditorOpen = false;
          drawer.close();
        }
      });
    }

    class CustomCartDrawer extends HTMLElement {
      connectedCallback() {
        if (this.__ready) return;
        this.__ready = true;

        this.sectionId = this.dataset.sectionId;
        this.panel = this.querySelector('.ccd__panel');
        this.queue = Promise.resolve();
        this.isOpen = false;
        this.activeElement = null;
        this.qtyTimers = {};
        this.refreshTimer = null;
        this.pendingOpen = false;

        this.onKeydown = this.onKeydown.bind(this);
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('input', this.onInput.bind(this));
        this.addEventListener('keydown', this.onFieldKeydown.bind(this));

        this.initTimer();

        if (window.Shopify && window.Shopify.designMode && window.__ccdEditorOpen) {
          this.open();
        }
      }

      disconnectedCallback() {
        clearInterval(this.timerInterval);
        document.removeEventListener('keydown', this.onKeydown);
        if (this.isOpen) this.unlockScroll();
      }

      get openOnAdd() {
        return this.dataset.openOnAdd !== 'false';
      }

      /* ---------- Dawn product form contract ---------- */

      getSectionsToRender() {
        var live = getLive();
        var id = live ? live.dataset.sectionId : this.sectionId;
        return [{ id: id }, { id: 'cart-icon-bubble' }];
      }

      setActiveElement(element) {
        var live = getLive();
        if (live && live !== this) return live.setActiveElement(element);
        this.activeElement = element;
      }

      renderContents(parsedState) {
        var live = getLive();
        if (live && live !== this) return live.renderContents(parsedState);

        var sections = parsedState && parsedState.sections;
        if (sections && sections[this.sectionId]) {
          this.renderSections(sections);
          this.announce();
        } else {
          this.refresh();
        }
        if (this.openOnAdd) this.open(this.activeElement);
      }

      /* ---------- Open / close ---------- */

      open(trigger) {
        if (trigger) this.activeElement = trigger;
        this.classList.toggle('is-empty', !this.querySelector('.ccd-item'));
        if (this.isOpen) return;
        this.isOpen = true;
        this.lockScroll();
        this.classList.add('is-open');
        document.addEventListener('keydown', this.onKeydown);

        var self = this;
        requestAnimationFrame(function () {
          var close = self.querySelector('.ccd__close');
          (close || self.panel).focus({ preventScroll: true });
        });
        this.initTimer();
        this.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKeydown);

        var self = this;
        var speed = parseFloat(getComputedStyle(this).getPropertyValue('--ccd-speed')) || 350;
        setTimeout(function () {
          if (!self.isOpen) self.unlockScroll();
        }, speed);

        if (this.activeElement && document.contains(this.activeElement)) {
          try {
            this.activeElement.focus({ preventScroll: true });
          } catch (e) {
            /* element not focusable */
          }
        }
        this.dispatchEvent(new CustomEvent('cart-drawer:close', { bubbles: true }));
      }

      lockScroll() {
        var scrollbar = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--ccd-scrollbar', Math.max(scrollbar, 0) + 'px');
        document.documentElement.classList.add('ccd-locked');
      }

      unlockScroll() {
        document.documentElement.classList.remove('ccd-locked');
        document.documentElement.style.removeProperty('--ccd-scrollbar');
      }

      onKeydown(event) {
        if (!this.isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        var focusables = Array.prototype.filter.call(
          this.panel.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
          ),
          function (el) {
            return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
          }
        );
        if (!focusables.length) {
          event.preventDefault();
          this.panel.focus();
          return;
        }
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      /* ---------- Events inside the drawer ---------- */

      onClick(event) {
        var target = event.target;

        var closer = target.closest('[data-ccd-close]');
        if (closer) {
          if (closer.classList.contains('ccd__overlay') && this.dataset.closeOnOverlay === 'false') return;
          event.preventDefault();
          this.close();
          return;
        }

        var qtyBtn = target.closest('[data-ccd-qty-btn]');
        if (qtyBtn) {
          event.preventDefault();
          this.stepQuantity(qtyBtn);
          return;
        }

        var remove = target.closest('[data-ccd-remove]');
        if (remove) {
          event.preventDefault();
          var item = remove.closest('.ccd-item');
          if (item) this.changeLine(item.dataset.key, 0);
          return;
        }

        var add = target.closest('[data-ccd-add]');
        if (add) {
          event.preventDefault();
          this.addVariant(add);
          return;
        }

        var apply = target.closest('[data-ccd-discount-apply]');
        if (apply) {
          event.preventDefault();
          this.applyDiscount();
          return;
        }

        var removeCode = target.closest('[data-ccd-discount-remove]');
        if (removeCode) {
          event.preventDefault();
          this.removeDiscount(removeCode.getAttribute('data-ccd-discount-remove'));
        }
      }

      onChange(event) {
        var input = event.target.closest('[data-ccd-qty-input]');
        if (!input) return;
        var item = input.closest('.ccd-item');
        if (!item) return;
        var value = this.normaliseQuantity(input, parseInt(input.value, 10));
        input.value = value;
        if (value === parseInt(input.dataset.current, 10)) return;
        this.scheduleQuantity(item.dataset.key, value, 0);
      }

      onInput(event) {
        var note = event.target.closest('[data-ccd-note]');
        if (!note) return;
        var self = this;
        clearTimeout(this.noteTimer);
        this.noteTimer = setTimeout(function () {
          nativeFetch(rootUrl() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: note.value })
          }).catch(function () {});
        }, 400);
      }

      onFieldKeydown(event) {
        if (event.key !== 'Enter') return;
        if (event.target.closest('[data-ccd-discount-input]')) {
          event.preventDefault();
          this.applyDiscount();
        } else if (event.target.closest('[data-ccd-qty-input]')) {
          event.preventDefault();
          event.target.blur();
        }
      }

      /* ---------- Quantity ---------- */

      normaliseQuantity(input, value) {
        var min = parseInt(input.dataset.min, 10) || 1;
        var step = parseInt(input.dataset.step, 10) || 1;
        var max = parseInt(input.dataset.max, 10);
        if (isNaN(value) || value <= 0) return 0;
        if (value < min) value = min;
        if (step > 1) value = Math.max(min, Math.round(value / step) * step);
        if (!isNaN(max) && max > 0 && value > max) value = max;
        return value;
      }

      stepQuantity(button) {
        var item = button.closest('.ccd-item');
        var input = item && item.querySelector('[data-ccd-qty-input]');
        if (!input) return;
        var step = parseInt(input.dataset.step, 10) || 1;
        var min = parseInt(input.dataset.min, 10) || 1;
        var current = parseInt(input.value, 10) || 0;
        var next = button.dataset.ccdQtyBtn === 'plus' ? current + step : current - step;
        if (button.dataset.ccdQtyBtn === 'minus' && next < min) next = 0;
        next = this.normaliseQuantity(input, next);
        input.value = next;
        this.scheduleQuantity(item.dataset.key, next, 350);
      }

      scheduleQuantity(key, quantity, delay) {
        var self = this;
        clearTimeout(this.qtyTimers[key]);
        this.qtyTimers[key] = setTimeout(function () {
          delete self.qtyTimers[key];
          self.changeLine(key, quantity);
        }, delay);
      }

      changeLine(key, quantity) {
        var self = this;
        return this.request('cart/change.js', { id: key, quantity: quantity })
          .then(function () {
            self.announce();
          })
          .catch(function (error) {
            self.refresh().then(function () {
              self.showLineError(key, error);
            });
          });
      }

      showLineError(key, error) {
        var item = Array.prototype.find.call(this.querySelectorAll('.ccd-item'), function (el) {
          return el.dataset.key === key;
        });
        var box = item && item.querySelector('[data-ccd-error]');
        var message = (error && (error.description || error.message)) || this.dataset.errorText;
        if (box) {
          box.textContent = message;
          box.classList.add('is-visible');
        } else {
          this.setLive(message);
        }
      }

      /* ---------- Add (upsells / recommendations) ---------- */

      addVariant(button) {
        var card = button.closest('.ccd-rec');
        var select = card && card.querySelector('[data-ccd-variant]');
        var id = parseInt(select ? select.value : button.dataset.variantId, 10);
        if (!id) return;
        var self = this;
        button.classList.add('is-loading');
        this.request('cart/add.js', { items: [{ id: id, quantity: 1 }] }, { productVariantId: String(id) })
          .then(function () {
            self.announce();
          })
          .catch(function (error) {
            self.setLive((error && (error.description || error.message)) || self.dataset.errorText);
          })
          .finally(function () {
            if (document.contains(button)) button.classList.remove('is-loading');
          });
      }

      /* ---------- Discount codes ---------- */

      currentCodes() {
        return Array.prototype.map.call(this.querySelectorAll('[data-ccd-code]'), function (el) {
          return el.getAttribute('data-ccd-code');
        });
      }

      showDiscountError(message) {
        var box = this.querySelector('[data-ccd-discount-error]');
        if (!box) return;
        box.textContent = message || '';
        box.classList.toggle('is-visible', Boolean(message));
      }

      applyDiscount() {
        var input = this.querySelector('[data-ccd-discount-input]');
        if (!input) return;
        var code = input.value.trim();
        if (!code) return;
        this.showDiscountError('');

        var existing = this.currentCodes();
        var lower = code.toLowerCase();
        if (existing.some(function (c) { return c.toLowerCase() === lower; })) {
          this.showDiscountError(this.dataset.discountDuplicate);
          return;
        }

        var self = this;
        this.request('cart/update.js', { discount: existing.concat(code).join(',') })
          .then(function (cart) {
            var match = (cart.discount_codes || []).find(function (d) {
              return String(d.code).toLowerCase() === lower;
            });
            if (match && match.applicable) {
              var field = self.querySelector('[data-ccd-discount-input]');
              if (field) field.value = '';
              self.announce();
              return;
            }
            self.showDiscountError(self.dataset.discountError);
            return self.request('cart/update.js', { discount: existing.join(',') });
          })
          .catch(function () {
            self.showDiscountError(self.dataset.discountError);
          });
      }

      removeDiscount(code) {
        var lower = String(code).toLowerCase();
        var remaining = this.currentCodes().filter(function (c) {
          return c.toLowerCase() !== lower;
        });
        this.showDiscountError('');
        var self = this;
        this.request('cart/update.js', { discount: remaining.join(',') }).catch(function () {
          self.setLive(self.dataset.errorText);
        });
      }

      /* ---------- Requests ---------- */

      request(path, payload, meta) {
        var self = this;
        var body = Object.assign({}, payload, {
          sections: [this.sectionId, 'cart-icon-bubble'],
          sections_url: window.location.pathname
        });

        var run = function () {
          self.setLoading(true);
          return nativeFetch(rootUrl() + path, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          })
            .then(function (response) {
              return response
                .json()
                .catch(function () {
                  return {};
                })
                .then(function (data) {
                  if (!response.ok || (data && data.status && data.status >= 400)) throw data;
                  return data;
                });
            })
            .then(function (data) {
              if (data.sections) self.renderSections(data.sections);
              self.publishUpdate(data, meta);
              return data;
            })
            .finally(function () {
              self.setLoading(false);
            });
        };

        var next = this.queue.then(run, run);
        this.queue = next.catch(function () {});
        return next;
      }

      refresh() {
        var self = this;
        var run = function () {
          var url = window.location.pathname + '?sections=' + encodeURIComponent(self.sectionId + ',cart-icon-bubble');
          return nativeFetch(url, { headers: { Accept: 'application/json' } })
            .then(function (response) {
              return response.json();
            })
            .then(function (sections) {
              if (sections) self.renderSections(sections);
            })
            .catch(function (e) {
              console.error('[cart drawer] refresh failed', e);
            });
        };
        var next = this.queue.then(run, run);
        this.queue = next;
        return next;
      }

      onExternalChange(kind) {
        if (kind === 'add' && this.openOnAdd) this.pendingOpen = true;
        var self = this;
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(function () {
          self.refresh().then(function () {
            if (self.pendingOpen) {
              self.pendingOpen = false;
              self.open();
            }
          });
        }, 120);
      }

      publishUpdate(data, meta) {
        if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        try {
          publish(
            PUB_SUB_EVENTS.cartUpdate,
            Object.assign({ source: 'custom-cart-drawer', cartData: data }, meta || {})
          );
        } catch (e) {
          /* Theme pub/sub unavailable */
        }
      }

      setLoading(state) {
        if (this.panel) this.panel.classList.toggle('is-loading', state);
        this.setAttribute('aria-busy', state ? 'true' : 'false');
      }

      /* ---------- Rendering ---------- */

      renderSections(sections) {
        var html = sections[this.sectionId];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector(TAG);
          if (next) {
            var scroller = this.querySelector('[data-ccd-scroll]');
            var scrollTop = scroller ? scroller.scrollTop : 0;
            var focused = document.activeElement;
            var focusKey = focused && this.contains(focused) ? focused.getAttribute('data-ccd-focus') : null;

            var self = this;
            next.querySelectorAll('[data-ccd-region]').forEach(function (source) {
              var name = source.getAttribute('data-ccd-region');
              var target = self.querySelector('[data-ccd-region="' + name + '"]');
              if (target) target.innerHTML = source.innerHTML;
            });

            this.classList.toggle('is-empty', next.classList.contains('is-empty'));
            if (scroller) scroller.scrollTop = scrollTop;
            this.initTimer();

            if (focusKey) {
              var again = this.querySelector('[data-ccd-focus="' + focusKey.replace(/"/g, '\\"') + '"]');
              if (again && !again.disabled) {
                again.focus({ preventScroll: true });
              } else if (this.isOpen) {
                this.panel.focus({ preventScroll: true });
              }
            }
          }
        }

        var bubbleHtml = sections['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubbleHtml && bubble) {
          var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          var source = bubbleDoc.querySelector('.shopify-section');
          if (source) bubble.innerHTML = source.innerHTML;
        }
      }

      announce() {
        var title = this.querySelector('[data-ccd-region="title"]');
        this.setLive(title ? title.textContent.trim() : '');
      }

      setLive(message) {
        var live = this.querySelector('[data-ccd-live]');
        if (!live) return;
        live.textContent = '';
        setTimeout(function () {
          live.textContent = message || '';
        }, 50);
      }

      /* ---------- Reservation timer ---------- */

      initTimer() {
        clearInterval(this.timerInterval);
        var minutes = parseInt(this.dataset.timerMinutes, 10);
        var nodes = this.querySelectorAll('[data-ccd-timer]');
        if (!minutes || !nodes.length) return;

        var key = 'ccd-timer-end';
        var store = null;
        try {
          store = window.sessionStorage;
        } catch (e) {
          store = null;
        }
        var end = store ? Number(store.getItem(key)) : 0;

        var tick = function () {
          var now = Date.now();
          if (!end || end <= now) {
            end = now + minutes * 60000;
            try {
              if (store) store.setItem(key, String(end));
            } catch (e) {
              /* storage full or blocked */
            }
          }
          var left = Math.max(0, Math.round((end - now) / 1000));
          var text = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
          nodes.forEach(function (node) {
            node.textContent = text;
          });
        };

        tick();
        this.timerInterval = setInterval(tick, 1000);
      }
    }

    customElements.define(TAG, CustomCartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('aro-sticky-atc')) return;

    class AroStickyAtc extends HTMLElement {
      connectedCallback() {
        var self = this;
        var json = this.querySelector('[data-satc-json]');
        if (!json) return;
        try { this.data = JSON.parse(json.textContent); } catch (err) { return; }

        this.ac = new AbortController();
        var sig = { signal: this.ac.signal };
        this.form = this.querySelector('form');
        this.idInput = this.form.querySelector('input[name="id"]');
        this.qtyInput = this.form.querySelector('input[name="quantity"]');
        this.button = this.querySelector('[data-satc-submit]');
        this.label = this.querySelector('[data-satc-label]');
        this.priceEl = this.querySelector('[data-satc-price]');
        this.compareEl = this.querySelector('[data-satc-compare]');
        this.imageEl = this.querySelector('[data-satc-image]');
        this.errorEl = this.querySelector('[data-satc-error]');
        this.selects = Array.prototype.slice.call(this.querySelectorAll('[data-satc-option]'));
        this.low = parseInt(this.dataset.low, 10) || 0;
        this.showLow = this.dataset.showLow === 'true';
        this.mainSeen = false;
        this.mainVisible = true;
        this.footerVisible = false;
        this.forced = false;

        this.variant = this.findById(Number(this.idInput.value)) || this.data.variants[0];

        this.selects.forEach(function (select) {
          select.addEventListener('change', function () { self.onOptionChange(Number(select.dataset.satcOption)); }, sig);
        });
        this.querySelectorAll('[data-satc-qty]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var next = (parseInt(self.qtyInput.value, 10) || 1) + Number(btn.dataset.satcQty);
            self.qtyInput.value = Math.max(1, next);
          }, sig);
        });
        this.qtyInput.addEventListener('change', function () {
          var v = parseInt(self.qtyInput.value, 10);
          self.qtyInput.value = isNaN(v) || v < 1 ? 1 : v;
        }, sig);

        /* Own add to cart: works with any theme, then hands the result to the cart drawer. */
        this.form.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.add();
        }, Object.assign({ capture: true }, sig));

        /* Dawn: the main form's hidden variant input fires change when a variant is picked. */
        document.addEventListener('change', function (e) {
          var t = e.target;
          if (!t || t.name !== 'id' || self.contains(t) || !t.form || !/\/cart\/add/.test(t.form.getAttribute('action') || '')) return;
          if (t.form.closest('product-card, .card-wrapper, quick-add-modal')) return;
          var match = self.findById(Number(t.value));
          if (match) self.applyVariant(match, true);
        }, sig);

        /* Follow the variant chosen in the main product form. */
        document.addEventListener('variant:change', function (e) {
          if (!e.detail || !e.detail.variant || self.contains(e.target)) return;
          var formId = e.detail.formId || (e.target && e.target.id) || '';
          if (self.form && formId === self.form.id) return;
          var match = self.findById(e.detail.variant.id);
          if (match) self.applyVariant(match, true);
        }, sig);

        this.applyVariant(this.variant, true);
        this.setupVisibility(sig);

        document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === self.dataset.sectionId) { self.forced = true; self.update(); } }, sig);
        document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === self.dataset.sectionId) { self.forced = false; self.update(); } }, sig);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        clearTimeout(this.busyTimer);
        document.documentElement.classList.remove('aro-satc-on');
        document.body && document.body.style.removeProperty('padding-bottom');
      }

      findById(id) {
        for (var i = 0; i < this.data.variants.length; i++) { if (this.data.variants[i].id === id) return this.data.variants[i]; }
        return null;
      }

      findByOptions(options) {
        for (var i = 0; i < this.data.variants.length; i++) {
          var v = this.data.variants[i], ok = true;
          for (var j = 0; j < options.length; j++) { if (v.options[j] !== options[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }

      currentOptions() { return this.selects.map(function (s) { return s.value; }); }

      onOptionChange(index) {
        var opts = this.currentOptions();
        var match = this.findByOptions(opts);
        if (!match) {
          var value = opts[index], best = null;
          for (var i = 0; i < this.data.variants.length; i++) {
            var v = this.data.variants[i];
            if (v.options[index] !== value) continue;
            if (!best) best = v;
            if (v.available) { best = v; break; }
          }
          match = best;
        }
        if (match) this.applyVariant(match, true);
      }

      applyVariant(variant, syncSelects) {
        var labels = this.data.labels;
        this.variant = variant;
        this.idInput.value = variant.id;
        if (syncSelects) this.selects.forEach(function (s, i) { if (variant.options[i] != null) s.value = variant.options[i]; });

        if (this.priceEl) this.priceEl.innerHTML = variant.price;
        if (this.compareEl) {
          if (variant.compare) { this.compareEl.innerHTML = variant.compare; this.compareEl.hidden = false; }
          else { this.compareEl.hidden = true; }
        }
        if (this.imageEl && variant.image) {
          this.imageEl.removeAttribute('srcset');
          this.imageEl.src = variant.image;
        }
        this.button.disabled = !variant.available;
        this.label.textContent = variant.available ? labels.add : labels.soldOut;
        this.hideError();
        this.updateOptionLabels();
      }

      updateOptionLabels() {
        var self = this, labels = this.data.labels, opts = this.currentOptions();
        this.selects.forEach(function (select, index) {
          Array.prototype.forEach.call(select.options, function (option) {
            var test = opts.slice(); test[index] = option.dataset.value;
            var v = self.findByOptions(test), suffix = '';
            if (!v) suffix = labels.unavailable;
            else if (!v.available) suffix = labels.soldOutSuffix;
            else if (self.showLow && self.low > 0 && v.qty !== null && v.qty > 0 && v.qty <= self.low) suffix = labels.low;
            option.textContent = option.dataset.value + (suffix ? ' (' + suffix + ')' : '');
          });
        });
      }

      root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

      /* Section ids the open cart drawer needs re-rendered, collected the way each theme expects. */
      drawerSections() {
        var ids = [];
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: ids } })); } catch (err) {}
        var ccdEl = document.querySelector('custom-cart-drawer');
        if (ccdEl && typeof ccdEl.getSectionsToRender === 'function') {
          try { ccdEl.getSectionsToRender().forEach(function (sec) { ids.push(sec.section || sec.id); }); } catch (err) {}
        }
        var dawn = document.querySelector('cart-drawer, cart-notification');
        if (dawn && typeof dawn.getSectionsToRender === 'function') {
          try { dawn.getSectionsToRender().forEach(function (sec) { ids.push(sec.section || sec.id); }); } catch (err) {}
        }
        return ids.filter(function (id, i) { return id && ids.indexOf(id) === i; }).slice(0, 5);
      }

      async add() {
        if (!this.variant || !this.variant.available || this.button.getAttribute('aria-busy') === 'true') return;
        var self = this, labels = this.data.labels;
        var qty = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
        var sections = this.drawerSections();
        this.hideError();
        this.setBusy(true);
        try {
          var body = { items: [{ id: this.variant.id, quantity: qty }] };
          if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
          var res = await fetch(this.root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          });
          var data = await res.json().catch(function () { return {}; });
          if (!res.ok || data.status) {
            this.showError(data.description || data.message || labels.error);
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            return;
          }
          var cart = await (await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();
          cart.sections = data.sections || {};
          this.openDrawer(cart, data);
        } catch (err) {
          this.showError(labels.error);
        } finally {
          this.setBusy(false);
        }
      }

      openDrawer(cart, added) {
        var opened = false;
        var html = document.documentElement;
        var items = (added && added.items) || [];

        /* 0a. Alice Grace Mae custom cart drawer (custom-cart-drawer): render the bundled section and open it. */
        var ccd = document.querySelector('custom-cart-drawer');
        if (ccd && typeof ccd.renderContents === 'function') {
          try {
            ccd.renderContents({ sections: cart.sections });
            if (typeof ccd.open === 'function' && ccd.dataset.openOnAdd !== 'false') ccd.open();
          } catch (err) {
            if (typeof ccd.refresh === 'function') Promise.resolve(ccd.refresh()).then(function () { if (typeof ccd.open === 'function') ccd.open(); });
          }
          opened = true;
        }

        /* 0. Custom drawers with open(), like the Dawn custom drawer (ps-cart-drawer, id cart-drawer). */
        var custom = document.querySelector('ps-cart-drawer') || document.getElementById('cart-drawer');
        if (!opened && custom && typeof custom.open === 'function' && typeof custom.renderContents !== 'function') {
          var refreshed = typeof custom.refresh === 'function' ? Promise.resolve(custom.refresh()).catch(function () {}) : Promise.resolve();
          refreshed.then(function () { custom.open(); });
          if (typeof custom.syncCounts === 'function') custom.syncCounts();
          document.dispatchEvent(new CustomEvent('petitsol:cart-updated'));
          document.dispatchEvent(new CustomEvent('petitsol:cart-count'));
          opened = true;
        }

        /* 1. Custom MC cart drawer. */
        var mc = document.querySelector('mc-cart-drawer');
        if (!opened && mc && typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
          opened = true;
        }

        /* 2. Prestige / Impulse style drawer: cart:change with the bundled section opens it. */
        var prestige = document.querySelector('cart-drawer');
        if (!opened && prestige && typeof prestige.show === 'function' && typeof prestige.renderContents !== 'function') {
          html.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
          setTimeout(function () { if (!prestige.hasAttribute('open')) prestige.show(); }, 350);
          opened = true;
        }

        /* 3. Dawn style drawer. */
        var dawn = document.querySelector('cart-drawer, cart-notification');
        if (!opened && dawn && typeof dawn.renderContents === 'function') {
          try {
            var item = items[0] || {};
            dawn.renderContents(Object.assign({}, item, { id: item.key || item.id, key: item.key, sections: cart.sections }));
            var empty = dawn.classList && dawn.classList.contains('is-empty');
            if (empty) dawn.classList.remove('is-empty');
            opened = true;
          } catch (err) {}
        }

        /* 4. Horizon style drawer. */
        var horizon = document.querySelector('cart-drawer-component');
        if (!opened && horizon) {
          if (typeof horizon.open === 'function') horizon.open(); else if (typeof horizon.showDialog === 'function') horizon.showDialog();
          opened = true;
        }

        /* Tell the rest of the theme (cart count, cart items) the cart changed. */
        var update = new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: this.id, data: { source: 'aro-sticky-atc', itemCount: cart.item_count, sections: {} } } });
        if (mc) update.__mcDrawer = true;
        document.dispatchEvent(update);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.querySelectorAll('cart-count, .cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (n) {
          if (!n.children.length) n.textContent = cart.item_count;
        });

        /* Go to the cart page only when the page has no cart drawer at all. */
        var anyDrawer = document.querySelector('custom-cart-drawer, ps-cart-drawer, mc-cart-drawer, cart-drawer, cart-notification, cart-drawer-component, #cart-drawer, #CartDrawer, [id*="cart-drawer" i], [id*="cartdrawer" i], [class*="cart-drawer" i], [data-cart-drawer]');
        if (!opened && !anyDrawer) window.location.href = this.form.dataset.cartUrl || '/cart';
      }

      setBusy(on) {
        if (!this.button) return;
        this.button.setAttribute('aria-busy', on ? 'true' : 'false');
        if (!on) clearTimeout(this.busyTimer);
      }

      showError(msg) {
        if (!this.errorEl) return;
        var self = this;
        this.errorEl.textContent = msg;
        this.errorEl.hidden = false;
        clearTimeout(this.errorTimer);
        this.errorTimer = setTimeout(function () { self.hideError(); }, 4000);
      }

      hideError() { if (this.errorEl) this.errorEl.hidden = true; }

      setupVisibility(sig) {
        var self = this, trigger = this.dataset.trigger;
        var main = null;
        if (trigger === 'after_button') {
          var mainForm = document.querySelector('form[id^="product-form-main-"]');
          if (!mainForm) {
            var forms = document.querySelectorAll('main form[action*="/cart/add"], #MainContent form[action*="/cart/add"]');
            for (var f = 0; f < forms.length; f++) { if (!self.contains(forms[f]) && !forms[f].closest('product-card, .product-card, .card-wrapper, quick-buy-drawer, quick-add-modal')) { mainForm = forms[f]; break; } }
          }
          if (mainForm) {
            main = mainForm.querySelector('buy-buttons, [type="submit"]') || mainForm;
            var mainProduct = mainForm.querySelector('input[name="product-id"]');
            if (mainProduct && mainProduct.value !== this.dataset.productId) main = null;
          }
          if (!main) trigger = 'after_scroll';
        }
        this.mode = trigger;

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.target === main) {
                self.mainVisible = entry.isIntersecting;
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0) self.mainSeen = true;
                if (entry.isIntersecting || entry.boundingClientRect.top > 0) self.mainSeen = false;
              } else {
                self.footerVisible = entry.isIntersecting;
              }
            });
            self.update();
          });
          if (main) this.io.observe(main);
          if (this.dataset.hideFooter === 'true') {
            var footer = document.querySelector('footer.footer, .footer, footer');
            if (footer && !footer.contains(this)) this.io.observe(footer);
          }
        }

        window.addEventListener('scroll', function () { if (self.mode === 'after_scroll') self.update(); }, Object.assign({ passive: true }, sig));
        window.addEventListener('resize', function () { self.update(); }, sig);
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(function () { self.update(); });
          this.ro.observe(this);
        }
        this.update();
      }

      update() {
        var show = false;
        if (this.mode === 'always') show = true;
        else if (this.mode === 'after_button') show = this.mainSeen && !this.mainVisible;
        else show = window.scrollY > (parseInt(this.dataset.offset, 10) || 0);
        if (this.footerVisible) show = false;
        if (this.forced) show = true;

        var enabledHere = window.getComputedStyle(this).display !== 'none';
        var visible = show && enabledHere;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) this.removeAttribute('inert'); else this.setAttribute('inert', '');

        document.documentElement.classList.toggle('aro-satc-on', visible);
        if (document.body) {
          if (visible) document.body.style.paddingBottom = this.offsetHeight + 'px';
          else document.body.style.removeProperty('padding-bottom');
        }
      }
    }

    customElements.define('aro-sticky-atc', AroStickyAtc);
  })();

  } catch(e) { console.error(e); }
})();
})();
